import { apiClient } from '../../../app/api/apiClient';
import type { OrderStatus, OrdersPage } from '../types/order.types';

interface OrdersEnvelope {
  success: boolean;
  data: {
    items: OrdersPage['items'];
    total: number;
    page: number;
    page_size: number;
  };
}

export async function listOrders(
  page: number,
  pageSize = 20,
  status?: OrderStatus,
): Promise<OrdersPage> {
  const response = await apiClient.get('/api/super-admin/orders', {
    query: {
      page,
      page_size: pageSize,
      ...(status ? { status } : {}),
    },
  });
  const data = response.data as OrdersEnvelope;
  const totalPages = data.data.total
    ? Math.ceil(data.data.total / data.data.page_size)
    : 0;
  return {
    items: data.data.items,
    total_count: data.data.total,
    page: data.data.page,
    page_size: data.data.page_size,
    total_pages: totalPages,
  };
}
